import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=21173dd6&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=21173dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21173dd6",
  null
  
)

export default component.exports